function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessResponse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.65 159.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_26",
    "data-name": "Layer 26"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "35.93 66.35 35.74 70.8 47.62 75.83 59.07 81.96 64.43 85.99 65.39 83.88 56.38 77.61 47.19 71.62",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78,63.27,34.52,55l3.59,1.39s8.67,4.65,8.77,4.79,9,8,9,8,5.36,5.84,5.51,5.89,4.31,4.31,4.31,4.31l.57.76-1.58,3.88-8.62-7L48,72,40.7,68.68",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.67,84.57A102.36,102.36,0,0,0,29.51,64.51l-.69-.2,5-10.05.46.11c13.9,3.27,31.78,24.19,32.54,25.08l-.92.77c-.18-.21-18-21-31.43-24.56l-4,7.91A104.31,104.31,0,0,1,65.46,83.68Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,86.6c-7.68-6.91-28.4-15.16-28.6-15.24l-.43-.17.48-4.63,1.19.12-.38,3.73C39.5,71.66,57.63,79.13,65,85.71Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.1,
    cy: 134.27,
    rx: 34.98,
    ry: 6.3,
    style: {
      fill: "#4aaed2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,18.34l1.74,3.24s5.8-7.41,7.77-7.76L98.62,11S95.84,15,94,16.14A32.49,32.49,0,0,0,90.85,18.34Z",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,134.49l-.38,3.66s9-2.9,10.79-2.08l.11-3.28s-4.51,1.71-6.69,1.63A33.31,33.31,0,0,0,101,134.49Z",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65,35.54l1.74-3.6s.46.81,3,.7a11.86,11.86,0,0,1,5.1,1.16L47,37.39a4.93,4.93,0,0,0-3-.69",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.28,18s-.21,1,1.09,3.08a28.35,28.35,0,0,0,2.78,3.74L72,24s-1.13-2.27-1.8-3.69-1.66-3.2-1.66-3.2",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.89,133.4s.6.8,3,1.19a27.61,27.61,0,0,0,4.64.34l1.88-3.42s-2.45-.63-4-1-3.5-.83-3.5-.83",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,96.58s.87.48,3.27-.14a28,28,0,0,0,4.38-1.58L148.2,91s-2.5.42-4.06.65-3.54.66-3.54.66",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,25.85s0,1,1.75,2.77a28.69,28.69,0,0,0,3.55,3L127,30s-1.6-1.95-2.58-3.19-2.33-2.74-2.33-2.74",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22.9 92.23 20.35 94.67 25.79 98.96 29.85 95.13",
    style: {
      fill: "#4aaed2",
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07,86.31a13,13,0,0,1,0-2.18c.11-.35,3.1-10.59,3.1-10.59l4.26-8.06,3.28.8,7.66,1.56,3-.18L85,77.68l.35,8.81,1.49,9,2.71,7,2.88,3.8,4.66,3.16,3.62.64s2.94.11,3.17,0,4.26-.86,4.6-.86,4.72-2.88,4.72-2.88l6.22-5.18s3.91-5.87,4.14-6.1,4.32-9.67,4.61-10.24S131.72,70,131.72,70l.86,2.76-.69,6.33-2.53,10.42-5.64,10.19L119.17,106l-5.35,4.2-8.06,3.74-7.43,2.24H91.89l-6.79-.8-6.28-2.13",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,51.42l2.6,1.84,5.71,7.7,3,4.92,2.78,6.33.81,3.3-5.77-4,.9,6-5.29-6.85,0-4.44s-1.8-6.76-1.85-7S128.28,53,128.28,53",
    style: {
      fill: "#4aaed2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.73 52.06 45.77 48.06 55.88 37.03 62.18 32.69 64.09 31.77 67.63 35.71 69.93 40.7 69.47 43.66 68.35 47.01 65.27 50.42 62.31 50.16 56.73 49.83 51.48 50.42 48.46 50.75 44.32 52.52",
    style: {
      fill: "#1c2756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,31.4l-3.43,3.74L99.36,40l.12,3.3L100.73,47,104,51.22l4.68,3.5s.93-1.07,1.24-1.38,3.86-2.31,4.18-2.5,3.05-1.37,3.05-1.37,5.48.44,5.67.44l3.37.12-3.93-5.48-4.8-1.69L116.06,40h1.87l-2.06-2.43-8-4.93L104.59,31",
    style: {
      fill: "#d4eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.26,53.15s2.61-.87,3.18-1.18,4.11-1.44,4.3-1.56a29,29,0,0,1,4-.5c.62,0,7,.19,7,.19l4.55.43L73.49,53l6,2.81,5.3,1.74L88.88,59l4.3.18,2.75.13,3.49-.81,6.23-1.81,2.56-1.5-1.31,3.74L102,63.12l-4.12,2.5-4,1.62-6.42.87-8.54-.87L71.8,65.05l-5.92-2.3L60.4,60.07a15.41,15.41,0,0,0-1.75-1.87C58.4,58.14,55.91,56,55.91,56s-3-.74-3.24-.87-6.11-1.49-6.11-1.49Z",
    style: {
      fill: "#d4eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38,50.33l-5.22-.73-4.23.2c-.16,0-3,.94-3.19.94s-3.13,2-3.13,2a18.12,18.12,0,0,0-1.25,1.83c0,.15-.79,2.56-.79,2.56l.32,2.66.57,2.25s1.2,2.14,1.25,2.3S114.48,68,114.48,68l3.91,1.88,3.82,1.46s4.59.32,4.75.32a29.62,29.62,0,0,0,3,0c.15-.11,1.88-.94,1.88-.94a12.59,12.59,0,0,0,.52-1.78c0-.31-.73-4.7-.73-5.27s-1.67-6.06-1.78-6.53-2.61-6.48-2.61-6.48",
    style: {
      fill: "#cc9ec8"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.08 40.01 117.36 42.95 125.93 44.99 126.57 40.48",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.05,
    cy: 59.43,
    r: 6.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.16,
    cy: 58.05,
    r: 3.58,
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.6 74.78 32.61 77.86 43.21 82.42 51.07 84.58 59.04 86.18 64.06 86.63 65.08 86.18 69.75 86.18 74.08 87.2 77.04 89.14 80.12 93.81 81.71 100.64 81.26 106.45 79.43 111.47 77.95 114.31 74.08 117.39 67.02 121.61 59.04 122.97 53.69 122.17 50.84 120.58 49.82 118.42 49.93 116.82 52.66 114.2 48.68 114.54 40.93 114.43 35.92 113.06 32.95 111.5 31.51 109.97 30.88 108.35 27.31 107.09 23.53 104.57 21.46 101.54 39.79 98.36 32.68 96.26 22.6 91.91 18.97 88.7 17.17 86.33 18.22 82.7 21.4 84.56 33.34 88.43 38.71 89.81 33.01 85.61 28.3 80.63 27.07 77 27.6 74.78",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,49l6.81-10.31,6-13.18,1-4.47,1.27.53,2,4.89v6.38L141,39.38l3.4-4.24,5.53-7.66,2.23-6.17,1.06.43,1.49,4.14-1,4.78-2.12,5.11-3.21,6.16-3.18,4.56h1.68l5.22-2,10.2-7.68.18,2.28-1.14,4.86-2.1,4.2.84,1.92-.6,3.9-2.52,4-9.18,8.58.18.72s1.74.3,1.92.36,2.4,1.2,2.4,1.2l.36,2-.78,3.48-4.08,4.62-7,3.48-5.94,1.74-4.14.36,1.08-6.12.48-6.78,4.92,6.18-.78-6.48,6.24,4.2s-3-7.86-3.06-8.1-4.74-7.44-4.74-7.44-5.16-6.48-5.28-6.66-4.14-4.08-4.14-4.08",
    style: {
      fill: "#026397"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.31,32l1.87.65,3.5,4.39,1,3.34.08,2.2L68.93,46l-1.88,2.52-1.54,1.71a2.75,2.75,0,0,0,1.14.41c.49,0,5.86,1.87,5.86,1.87L78,55.61s4.72,1.71,5,1.71S87.24,59,87.65,59s3.42.41,3.66.49,4.39,0,4.39,0,3.59-.57,4-.74,4.15-1.38,4.15-1.38l4.81-2.6-3.5-2.28c-.25-.17-3.67-4.48-3.83-4.8s-1.63-3.18-1.71-3.5-.32-4.81-.32-4.81,1-2.28,1.22-2.6l2.36-3.34,1.87-2-1.38-1.31-9.2-2.6-7.33-1.06-6-.16-8.63,1.63L66.73,30.3l-2.36,1.06Z",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.93 67.92 84.97 78.39 85.45 89.21 88 99.28 90.76 104.44 95.99 108.72 99.85 109.96 103.23 110.17 105.99 110.03 111.85 107.55 116.46 104.51 120.6 99.21 124.46 93.42 127.42 86.18 129.35 80.32 130.32 74.88 131.21 70.33 129.42 71.64 124.53 71.71 118.67 70.47 112.33 66.75 109.36 62.47 108.4 58.13 108.33 55.86 106.61 58.96 101.92 63.64 98.2 65.23 95.58 66.54 93.1 67.16 89.52 67.78 85.93 67.92",
    style: {
      fill: "#fff1d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,66.16A6.89,6.89,0,1,1,125,59.28,6.89,6.89,0,0,1,118.1,66.16Zm0-12.77A5.89,5.89,0,1,0,124,59.28,5.89,5.89,0,0,0,118.1,53.39Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87,60c-5.17,0-11.22-1.76-20.15-6-17.36-8.19-30.3-.44-30.43-.36l-.52-.86c.13-.08,13.54-8.1,31.38.31s23.56,7,34.48,1.19l.47.88C103.53,58.14,99.16,60,93.87,60Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.53,50.75,64.87,50c3.14-2.72,4.64-5.61,4.45-8.57C69,36,63.13,32,63.07,32l.56-.83c.26.17,6.32,4.31,6.69,10.22C70.52,44.66,68.91,47.82,65.53,50.75Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.91,62a4,4,0,1,1,4-4A4,4,0,0,1,117.91,62Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,117.91,55Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,59.61a.51.51,0,0,1-.42-.23.5.5,0,0,1,.15-.69c12.41-8.09,15.71-14,16.3-17.58a6,6,0,0,0-.36-3.56c-11.81,10.53-16.43,9.66-16.62,9.62L144.3,47l.43-.62c9-12.8,9.85-19.24,9-22.39a4.54,4.54,0,0,0-1.31-2.19c-1.67,7.4-10.67,17.54-11.07,18l-1.47,1.65.62-2.12c3.74-12.77.51-16.76-.92-17.84-1,9.65-12.95,27.08-13.47,27.84a.51.51,0,0,1-.7.12.49.49,0,0,1-.12-.69c.13-.19,13-19,13.35-28.12l0-.66.63.2c.28.1,6.52,2.32,2.77,17.25,2.77-3.38,8.64-11,9.51-16.51l.1-.62.58.23a4.73,4.73,0,0,1,2.42,3.14c1,3.28.25,9.83-8.51,22.49,1.81-.29,6.54-1.83,15.31-9.75l.39-.35.34.41A6.22,6.22,0,0,1,163,41.2c-.59,3.77-4,10-16.76,18.33A.53.53,0,0,1,146,59.61Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.14,68.85a.5.5,0,0,1-.41-.22.5.5,0,0,1,.12-.69c11.33-8,14.16-13.37,14.53-16.45a3.83,3.83,0,0,0-.51-2.8.5.5,0,0,1,.76-.66,4.73,4.73,0,0,1,.74,3.58c-.39,3.29-3.31,8.92-14.94,17.14A.46.46,0,0,1,145.14,68.85Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,84.88l-.15-1,.62-.09a31.66,31.66,0,0,0,17-6.26c3.31-3.31,4.72-6,4-7.67-.88-2.22-5-2.37-5.07-2.37l0-1c.2,0,4.85.17,6,3,.85,2.13-.6,5.08-4.29,8.77-.29.26-6.66,5.68-17.61,6.53Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.05,109.25c-11.69,0-14.94-7.53-15-7.63l-.24-.59,17.23-2.74c-15.59-4.18-20-8.63-21-11.68a4.46,4.46,0,0,1,.72-4.16l.39-.43.37.45c1.55,1.88,11.29,4.57,17.3,6-12-8.06-8.86-13.93-8.71-14.19l.27-.47.45.31c15.65,10.87,36.47,12,36.68,12a.5.5,0,0,1,.48.53.48.48,0,0,1-.53.47c-.2,0-20.85-1.12-36.67-11.82-.42,1.65-.62,7,11.09,13.91l2.71,1.6-3.07-.68c-1.78-.39-16.73-3.78-20.3-6.6a3.5,3.5,0,0,0-.21,2.78c.92,3,5.59,7.36,22.58,11.58l2.39.59-20.73,3.31c1.28,2.27,7.14,10.07,25,4.51a.5.5,0,0,1,.63.32.51.51,0,0,1-.33.63A38.93,38.93,0,0,1,36.05,109.25Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.16,123.37c-.66,0-1.27,0-1.8-.09-3.39-.35-6.27-1.73-7.52-3.6a3.07,3.07,0,0,1-.48-3A4.1,4.1,0,0,1,51,114.9c-11.14.87-16.23-1.17-18.56-3.15a5.18,5.18,0,0,1-2-3.42.51.51,0,0,1,.48-.52.54.54,0,0,1,.52.48A4.23,4.23,0,0,0,33.19,111c2.44,2,8.15,4.12,21.54,2.5l.15,1c-1.06.2-4,1-4.6,2.55a2.11,2.11,0,0,0,.39,2.05c.85,1.28,3.08,2.78,6.79,3.16,3.87.4,11.69-.26,20.66-9.11l.34-.25a.5.5,0,0,1,.69.11.51.51,0,0,1-.11.7l-.28.2C70.77,121.82,63.57,123.37,59.16,123.37Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.56,
    y: 116.38,
    width: 1,
    height: 18.64,
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.48,137.7a.51.51,0,0,1-.5-.41.5.5,0,0,1,.41-.58l16.45-3a.5.5,0,0,1,.59.4.5.5,0,0,1-.41.58l-16.45,3Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.06,135.52l-.14,0-8.74-2.69a.5.5,0,0,1,.3-1l8.73,2.69a.51.51,0,0,1,.33.63A.5.5,0,0,1,91.06,135.52Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,117.29a.47.47,0,0,1-.28-.09L119.3,106.6l-.52-.52a.49.49,0,1,1,.7-.7l.46.45,15.26,10.55a.5.5,0,0,1,.13.7A.49.49,0,0,1,134.92,117.29Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46,120.82a.51.51,0,0,1-.36-.15.49.49,0,0,1,0-.7L143,108.15a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.71l-11.85,11.81A.49.49,0,0,1,131.46,120.82Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,117.29l-.15,0a.51.51,0,0,1-.33-.63l2.76-8.71a.51.51,0,0,1,.63-.33.5.5,0,0,1,.32.63l-2.75,8.71A.5.5,0,0,1,134.92,117.29Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,69.94a13.5,13.5,0,0,1-1.35.52,17.91,17.91,0,0,1-10.69-.31c-7.56-2.45-12.32-8.73-10.61-14,.82-2.53,3-4.46,6.13-5.44A15.7,15.7,0,0,1,120,50a19.8,19.8,0,0,1,6,1c.4.13.8.28,1.18.43a8.66,8.66,0,0,1-.42-1.21l-.45-.17a18.84,18.84,0,0,0-11.29-.3c-3.45,1.08-5.86,3.24-6.78,6.08-1.88,5.8,3.17,12.65,11.26,15.27a20.5,20.5,0,0,0,6.34,1,16.74,16.74,0,0,0,4.95-.72c.38-.12.75-.26,1.11-.41A5.35,5.35,0,0,1,131.87,69.94Z",
    style: {
      fill: "#a574a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.28,45.7l-9.17-2.29-1.85-4,11.89.79Zm-8.46-3.15,7.64,1.92.53-3.36-9.12-.61Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.06,79.68l-6.2-8.39.8-.59,4,5.36-.68-5.81,5.67,3.93L140,69.61a58.56,58.56,0,0,0-13.49-18.75l-.65-.46.59-.81.68.49a59.46,59.46,0,0,1,13.8,19.17l2.69,7.53-6.41-4.44Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.14,114.5l-.73-.68c.06-.06,5.89-6.53,2.72-18.29-1.31-4.86-4.23-7.77-8.68-8.65a15.65,15.65,0,0,0-6.37.14l-.26-1a16.57,16.57,0,0,1,6.83-.15c3.33.66,7.68,2.82,9.45,9.37C84.42,107.6,78.4,114.23,78.14,114.5Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,86.69l.51.46a1.66,1.66,0,0,0,.67-.17c.4-.17.4-.37.4-.37l-.2-.13",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41,67.87c-.09-.34-.13-.7-.25-1l0-.09-.06-.06,0,0-.31,0c-6.23,45.1-29.6,43.09-29.86,43.06A14.48,14.48,0,0,1,91.12,104c-8.69-11.3-4.48-35.44-4.43-35.68l-1-.18c-.18,1-4.34,24.81,4.63,36.46a15.39,15.39,0,0,0,11.43,6.11s.24,0,.63,0c3.86,0,24.08-2,30.12-42.61A.75.75,0,0,1,132.41,67.87Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,30.8l.06-.05A6.55,6.55,0,0,1,104,30a52,52,0,0,0-11.24-3.36c-34.1-6.08-50,26-50.14,26.35l-.33.7.77,0c.11,0,10.92.38,14.93,4.55C59.64,60,65,63.21,71.74,65.53A50,50,0,0,0,65,82.5,29.52,29.52,0,0,0,64.42,87a2.74,2.74,0,0,1,1-.21,28,28,0,0,1,.5-4.1,48.84,48.84,0,0,1,6.77-16.84C78.64,67.78,85.5,69,91.82,68c8-1.23,13.83-5.62,17.49-13.05l.22-.43-.43-.23c-.09,0-8.41-4.5-9.24-11.49-.44-3.7,1.28-7.49,5.11-11.27a48.31,48.31,0,0,1,12.8,8.62l.15,0h1.26A48.94,48.94,0,0,0,105.74,30.8ZM98.87,42.92c.79,6.65,7.53,11,9.33,12A21.5,21.5,0,0,1,91.67,67c-14.37,2.23-30.5-6.84-33-9.43C55,53.76,46.49,52.94,43.84,52.77c2.49-4.58,18.1-30.59,48.7-25.13A51.33,51.33,0,0,1,104,31.1C100.12,35,98.4,39,98.87,42.92Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.86,53.91a45.2,45.2,0,0,0-6.1-9.8.38.38,0,0,1-.1,0l-.11-.06s0,0-.08,0a.53.53,0,0,1-.28,0c-.32-.05-.63-.14-1-.21A44.35,44.35,0,0,1,128,54.32c6.79,14.95,4.83,30.74-5.82,46.92a27.11,27.11,0,0,1-7.76,7.81c-6.26,4.13-19,10.15-34.37,4.18,0,0-.58-.26-1.45-.76a2.63,2.63,0,0,1-.57.82,17.85,17.85,0,0,0,1.65.87,36.83,36.83,0,0,0,13.44,2.58,40.3,40.3,0,0,0,21.85-6.85,28.08,28.08,0,0,0,8-8.1C133.67,85.54,135.71,69,128.86,53.91Z",
    style: {
      fill: "#085170"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,70.27l-.46.17a17.91,17.91,0,0,1-10.69-.3c-7.56-2.45-12.32-8.74-10.61-14,.82-2.52,3-4.45,6.13-5.43A15.38,15.38,0,0,1,120,50a19.47,19.47,0,0,1,5.52.84,1.78,1.78,0,0,1-.17-1.09,18.49,18.49,0,0,0-10.3,0c-3.45,1.08-5.86,3.24-6.78,6.09-1.88,5.8,3.17,12.65,11.26,15.27a20.5,20.5,0,0,0,6.34,1,16.74,16.74,0,0,0,4.95-.72l.05,0A1.83,1.83,0,0,1,131,70.27Z",
    style: {
      fill: "#a574a5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.06,
    cy: 56.35,
    r: 0.96,
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessResponse);
export default __webpack_public_path__ + "static/media/success_response.c6829f43a8a8466390e9cf8230042dc7.svg";
export { ForwardRef as ReactComponent };